/**
 * Owner: Masa Bayu
 * File: fields.ts
 * Date:Time: 2026-10-14 10:48
 * Description: Official QXW field contract · 1.1.0 linePaint additive.
 */
export const QXW_ROOT_FIELDS = [
    'identity',
    'metadata',
    'settings',
    'theme',
    'assets',
    'fonts',
    'pages',
    'elements',
    'components',
    'animations',
    'interactions',
    'publication',
];
export const QXW_OPTIONAL_ROOT_FIELDS = ['tables'];
export const QXW_IDENTITY_FIELDS = ['id', 'schema', 'version', 'applicationVersion'];
export const QXW_METADATA_FIELDS = [
    'title',
    'author',
    'description',
    'language',
    'createdAt',
    'updatedAt',
];
export const QXW_SETTINGS_FIELDS = ['units', 'pageLayout'];
export const QXW_THEME_FIELDS = ['id', 'name'];
export const QXW_IDENTIFIED_FIELDS = ['id'];
export const QXW_PAGE_FIELDS = ['id', 'elementIds', 'width', 'height'];
export const QXW_ELEMENT_FIELDS = [
    'id',
    'type',
    'version',
    'name',
    'layout',
    'style',
    'content',
    'responsive',
    'animationIds',
    'interactionIds',
    'accessibility',
    'locked',
    'visible',
    'linePaint',
];
/** R11-LINE-01 fields · reserved `runs` not accepted (Q3). */
export const QXW_LINE_PAINT_FIELDS = [
    'extension',
    'wordStarts',
    'wordGaps',
    'direction',
    'script',
    'role',
    'column',
];
/** R11-LINE-02 fields · wordStarts/wordGaps forbidden. */
export const QXW_LINE_PAINT_02_FIELDS = [
    'extension',
    'segments',
    'direction',
    'script',
    'role',
    'column',
];
export const QXW_ELEMENT_LAYOUT_FIELDS = [
    'mode',
    'x',
    'y',
    'width',
    'height',
    'rotation',
    'zIndex',
];
export const QXW_TEXT_CONTENT_FIELDS = ['blocks', 'language'];
export const QXW_TEXT_LANGUAGE_FIELDS = ['languageCode'];
export const QXW_TEXT_BLOCK_FIELDS = ['type', 'inlines', 'language'];
export const QXW_TEXT_PARAGRAPH_BLOCK_FIELDS = ['type', 'inlines', 'language', 'format'];
export const QXW_TEXT_PARAGRAPH_FORMAT_FIELDS = [
    'spacingBefore',
    'spacingAfter',
    'lineSpacing',
    'alignment',
    'indentLeft',
    'indentRight',
    'firstLineIndent',
    'backgroundColor',
];
export const QXW_TEXT_HEADING_BLOCK_FIELDS = ['type', 'level', 'inlines', 'language'];
export const QXW_TEXT_QUOTE_BLOCK_FIELDS = ['type', 'inlines', 'language'];
export const QXW_TEXT_CODE_BLOCK_FIELDS = ['type', 'inlines', 'language'];
export const QXW_TEXT_RULE_BLOCK_FIELDS = ['type', 'color'];
export const QXW_TEXT_NOTE_BLOCK_FIELDS = ['type', 'id', 'inlines', 'language'];
export const QXW_TEXT_LIST_BLOCK_FIELDS = ['type', 'items', 'language'];
export const QXW_TEXT_LIST_ITEM_FIELDS = ['type', 'inlines', 'list', 'language'];
export const QXW_TEXT_FIGURE_BLOCK_FIELDS = [
    'type',
    'assetRef',
    'alt',
    'caption',
    'language',
];
export const QXW_TEXT_ASSET_REF_FIELDS = ['id'];
export const QXW_TEXT_CAPTION_BLOCK_FIELDS = ['type', 'inlines', 'language'];
export const QXW_TEXT_INLINE_FIELDS = ['type', 'text', 'marks', 'typography'];
export const QXW_TEXT_LINK_INLINE_FIELDS = [
    'type',
    'kind',
    'target',
    'title',
    'text',
    'marks',
    'typography',
];
/** VT-01 optional inline typography — ≠ QXFont · ≠ CSS. */
export const QXW_TEXT_TYPOGRAPHY_FIELDS = ['family', 'size', 'sourceFontName'];
export const QXW_TEXT_NOTE_REF_INLINE_FIELDS = ['type', 'targetRef'];
export const QXW_TEXT_MARK_FIELDS = ['type'];
export const QXW_TEXT_FORMAT_MARK_FIELDS = ['type', 'value'];
export const QXW_IMAGE_CONTENT_FIELDS = ['assetId', 'fit', 'position', 'src', 'raster'];
export const QXW_IMAGE_RASTER_FIELDS = ['samples', 'width', 'height', 'colorSpace', 'bitDepth', 'mask'];
export const QXW_IMAGE_RASTER_MASK_FIELDS = ['samples', 'width', 'height', 'colorSpace', 'bitDepth', 'matte'];
export const QXW_SVG_CONTENT_FIELDS = ['assetId', 'fit', 'position'];
export const QXW_SHAPE_CONTENT_FIELDS = ['kind'];
export const QXW_GROUP_CONTENT_FIELDS = ['childIds'];
export const QXW_COMPONENT_CONTENT_FIELDS = ['componentId'];
export const QXW_VIDEO_CONTENT_FIELDS = ['assetId'];
export const QXW_AUDIO_CONTENT_FIELDS = ['assetId'];
export const QXW_EMBED_CONTENT_FIELDS = ['resource'];
export const QXW_OVERLAY_CONTENT_FIELDS = ['childIds'];
export const QXW_ACCESSIBILITY_FIELDS = ['label', 'role', 'description'];
export const QXW_UNITS = ['px'];
export const QXW_COLLECTION_FIELDS = [
    'assets',
    'fonts',
    'pages',
    'elements',
    'components',
    'animations',
    'interactions',
];
//# sourceMappingURL=fields.js.map